import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Remove = ({ ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: 32,
        height: 32,
        fill: 'inherit',
        fillOpacity: 'inherit',
        ...props.sx,
      }}
      viewBox="0 0 24 24"
      data-testid="removeIcon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="inherit"
      />
      <path
        d="M10.8853 12L8.09868 14.7867C7.79087 15.0945 7.79087 15.5935 8.09868 15.9013C8.40648 16.2091 8.90553 16.2091 9.21334 15.9013L12 13.1147L14.7867 15.9013C15.0945 16.2091 15.5935 16.2091 15.9013 15.9013C16.2091 15.5935 16.2091 15.0945 15.9013 14.7867L13.1147 12L15.9013 9.21334C16.2091 8.90553 16.2091 8.40648 15.9013 8.09868C15.5935 7.79087 15.0945 7.79087 14.7867 8.09868L12 10.8853L9.21334 8.09868C8.90553 7.79087 8.40648 7.79087 8.09868 8.09867C7.79087 8.40648 7.79087 8.90553 8.09868 9.21334L10.8853 12Z"
        fill="#0B1421"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.83859 7.83859C8.29004 7.38714 9.02198 7.38714 9.47343 7.83859L12 10.3652L14.5266 7.83859C14.978 7.38714 15.71 7.38714 16.1614 7.83859C16.6129 8.29004 16.6129 9.02198 16.1614 9.47343L13.6348 12L16.1614 14.5266C16.6129 14.978 16.6129 15.71 16.1614 16.1614C15.71 16.6129 14.978 16.6129 14.5266 16.1614L12 13.6348L9.47343 16.1614C9.02198 16.6129 8.29004 16.6129 7.83859 16.1614C7.38714 15.71 7.38714 14.978 7.83859 14.5266L10.3652 12L7.83859 9.47343C7.38714 9.02198 7.38714 8.29004 7.83859 7.83859ZM8.95325 8.35876C8.78909 8.1946 8.52293 8.1946 8.35876 8.35876C8.1946 8.52293 8.1946 8.78909 8.35876 8.95325L11.4055 12L8.35876 15.0467C8.1946 15.2109 8.1946 15.4771 8.35876 15.6412C8.52293 15.8054 8.78909 15.8054 8.95325 15.6412L12 12.5945L15.0467 15.6412C15.2109 15.8054 15.4771 15.8054 15.6412 15.6412C15.8054 15.4771 15.8054 15.2109 15.6412 15.0467L12.5945 12L15.6412 8.95325C15.8054 8.78909 15.8054 8.52293 15.6412 8.35876C15.4771 8.1946 15.2109 8.1946 15.0467 8.35876L12 11.4055L8.95325 8.35876Z"
        fill="#0B1421"
      />
    </SvgIcon>
  );
};

export default Remove;
